import React, { useState } from 'react';
import {Drawer, Grid,Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { BackIcon, BackIconOnPrimary, BackRightIcon } from './CustomIcons';
import { common } from '@mui/material/colors';

const heightHeader = 80;
const useStyles = makeStyles((theme)=>({
    root: {
        zIndex: 1201 + '!important',
    },
    drawerPaper: {
        width: '50%',
        // height: '100vh',
        background: 'linear-gradient(' + theme.palette.primary.main + ',' + theme.palette.primary.dark +')',
        [theme.breakpoints.down('lg')]: {
            width: '70%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '90%',
            height: '100%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '90%',
            height: '100%',
        },
        padding: theme.spacing(3) + ' ' + theme.spacing(4),
    },
    large: {
        width: '50%',
        [theme.breakpoints.down('lg')]: {
            width: '60%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '70%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '90%',
        },
    },
    fixed:{
        position: 'fixed',
    },
    header:{
        backgroundColor: theme.palette.background.drawer,
        zIndex: 1001,
        paddingBottom: theme.spacing(2),
        height: theme.spacing(5)
    },
    content:{
        marginTop: heightHeader,
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0,3,3,3),
        },
        overflow: 'auto',
    },
    buttonBack: {
        width: theme.spacing(5),
        height: theme.spacing(5),
        boxShadow:'none',
        borderRadius: theme.spacing(10),
        borderColor: theme.palette.background.transparent,
        opacity: 1,
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        padding: theme.spacing(1.8,1,0,1),
        '&:hover': {
            opacity: 0.5,
        },
        position: 'fixed',
        top: theme.spacing(2),
        right:theme.spacing(3),
        zIndex: 1002,
    },
    otherButton: {
        width: theme.spacing(5),
        height: theme.spacing(5),
        boxShadow:'none',
        borderRadius: theme.spacing(10),
        borderColor: theme.palette.background.transparent,
        opacity: 0.5,
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        padding: theme.spacing(1.8,1,0,1),
        // backgroundColor: theme.palette.icon.trash,
        '&:hover': {
                opacity: 0.5,
            },

        position: 'fixed',
        top:theme.spacing(2),
         right:theme.spacing(3),
        zIndex: 1001,
    },
    buttonDisable: {
        opacity: 0.2,
    },
    buttonActive: {
        opacity: 1,
    },
    rightHeader: {
        position: 'fixed',
        top:theme.spacing(6),
        right:theme.spacing(6),
        zIndex: 1001,
    },
}));

export default function CustomDrawer(props){
    const classes = useStyles();
    const { children, onClose, open, large, title, enableBack, fullScreen, rightHeader,classContent } = props;
    return (
        <Drawer
            variant="temporary"
            anchor={'right'}
            open={open}
            onClose={onClose}
            classes={{
                root: classes.root,
                paper: large ? [classes.drawerPaper, classes.large].join(' ') : classes.drawerPaper,
            }}
            ModalProps={{
                keepMounted: true, // Better open performance on mobile.
            }}>
                {rightHeader && <Grid xs={12} item className={classes.rightHeader}>{rightHeader}</Grid>}
                {enableBack && 
                <Grid xs={12} item 
                    className={[classes.buttonBack, enableBack ? undefined : classes.buttonDisable].join(' ')} 
                    onClick={enableBack.action ? enableBack.action : ()=> onClose()} >
                    {enableBack.icon ? enableBack.icon : <BackRightIcon />}
                </Grid>}
                {!fullScreen && <Grid item container className={classes.header}>
                    <Grid xs={12} item>
                        <Typography variant='h6' color={common.white}>{title}</Typography>
                    </Grid>
                </Grid>}
                {fullScreen ? children : <Grid item xs={12} className={classContent ? [classContent, classes.content].join(' ') : classes.content}>
                                        {children}
                                    </Grid>}
        </Drawer>
    );
}